module.exports = __webpack_public_path__ + "img/task_delete_tag.67f5cdd2.svg";